var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastActionsTopImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 60,
    viewBox: "0 0 244 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_78_6927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.697 -50.3241H120.707V67.3226H15.697V-50.3241Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.7597 -48.4224H120.707V65.2412H17.7597V-48.4224Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.5632 11.9062V3.92145H23.849V-1.40586H26.8905V-9.39062H27.6524V-1.40586H30.6939V3.92145H32.9735V11.9062H37.1548V14.1858H39.0566V22.9325H39.4406V10.3824H40.5804V18.3733H41.7202V-0.643929H42.4821V7.34084H45.5237V4.67718H46.6635V-6.3491H48.943V-17.3754H49.705V-15.8577H65.2966V-20.4169H67.9603V-37.9103H69.1001V-20.4169H72.9035V-15.8577H74.4274V6.96297H82.4121V0.118004H79.7485V-1.02179H82.4121V-2.92352H90.019V-20.4169H91.9208V-23.0806H101.045V-20.4169H102.185V3.92145H106.366V14.9477H108.652V6.20104H110.554V3.92145H114.735V-4.06331H117.015V-9.39062H119.678V-17.3754H120.707V65.2412H17.7597V11.9062H21.5632Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M58.3958 3.40112H59.4736V4.47897H58.3958V3.40112Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M58.3958 5.20996H59.4736V6.28781H58.3958V5.20996Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M60.1118 -0.210327H61.1897V0.867526H60.1118V-0.210327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M60.1118 3.40112H61.1897V4.47897H60.1118V3.40112Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M60.1118 5.20996H61.1897V6.28781H60.1118V5.20996Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M61.8216 -0.210327H62.8994V0.867526H61.8216V-0.210327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M61.8216 1.59229H62.8994V2.67013H61.8216V1.59229Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M61.8216 5.20996H62.8994V6.28781H61.8216V5.20996Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M63.5313 12.4327H64.6091V13.5106H63.5313V12.4327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M65.2407 8.82129H66.3186V9.89914H65.2407V8.82129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M65.2407 10.6239H66.3186V11.7017H65.2407V10.6239Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M65.2407 12.4327H66.3186V13.5106H65.2407V12.4327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M65.2407 14.2416H66.3186V15.3194H65.2407V14.2416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M65.2407 21.4644H66.3186V22.5422H65.2407V21.4644Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M66.9568 -0.210327H68.0347V0.867526H66.9568V-0.210327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M66.9568 1.59229H68.0347V2.67013H66.9568V1.59229Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M66.9568 7.01257H68.0347V8.09042H66.9568V7.01257Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M66.9568 8.82129H68.0347V9.89914H66.9568V8.82129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M66.9568 10.6239H68.0347V11.7017H66.9568V10.6239Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M66.9568 12.4327H68.0347V13.5106H66.9568V12.4327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M66.9568 14.2416H68.0347V15.3194H66.9568V14.2416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M66.9568 21.4644H68.0347V22.5422H66.9568V21.4644Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M68.6665 -0.210327H69.7444V0.867526H68.6665V-0.210327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M68.6665 1.59229H69.7444V2.67013H68.6665V1.59229Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M68.6665 3.40112H69.7444V4.47897H68.6665V3.40112Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M68.6665 5.20996H69.7444V6.28781H68.6665V5.20996Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M68.6665 7.01257H69.7444V8.09042H68.6665V7.01257Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M68.6665 8.82129H69.7444V9.89914H68.6665V8.82129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M68.6665 10.6239H69.7444V11.7017H68.6665V10.6239Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M68.6665 12.4327H69.7444V13.5106H68.6665V12.4327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M68.6665 14.2416H69.7444V15.3194H68.6665V14.2416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M68.6665 16.0442H69.7444V17.122H68.6665V16.0442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M70.376 -0.210327H71.4539V0.867526H70.376V-0.210327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M70.376 1.59229H71.4539V2.67013H70.376V1.59229Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M70.376 7.01257H71.4539V8.09042H70.376V7.01257Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M70.376 8.82129H71.4539V9.89914H70.376V8.82129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M70.376 10.6239H71.4539V11.7017H70.376V10.6239Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M70.376 12.4327H71.4539V13.5106H70.376V12.4327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M72.0857 -0.210327H73.1636V0.867526H72.0857V-0.210327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M72.0857 1.59229H73.1636V2.67013H72.0857V1.59229Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M72.0857 7.01257H73.1636V8.09042H72.0857V7.01257Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M72.0857 8.82129H73.1636V9.89914H72.0857V8.82129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M72.0857 10.6239H73.1636V11.7017H72.0857V10.6239Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M91.357 0.514404H92.4348V1.59225H91.357V0.514404Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M93.0667 0.514404H94.1445V1.59225H93.0667V0.514404Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M96.4922 0.514404H97.5701V1.59225H96.4922V0.514404Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M96.4922 2.32324H97.5701V3.40109H96.4922V2.32324Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M96.4922 4.13208H97.5701V5.20993H96.4922V4.13208Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M96.4922 5.93469H97.5701V7.01254H96.4922V5.93469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M96.4922 7.74353H97.5701V8.82138H96.4922V7.74353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M96.4922 9.54614H97.5701V10.624H96.4922V9.54614Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M96.4922 11.3549H97.5701V12.4327H96.4922V11.3549Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M98.2019 0.514404H99.2798V1.59225H98.2019V0.514404Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M98.2019 2.32324H99.2798V3.40109H98.2019V2.32324Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M98.2019 4.13208H99.2798V5.20993H98.2019V4.13208Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M98.2019 5.93469H99.2798V7.01254H98.2019V5.93469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M98.2019 7.74353H99.2798V8.82138H98.2019V7.74353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M98.2019 9.54614H99.2798V10.624H98.2019V9.54614Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M98.2019 11.3549H99.2798V12.4327H98.2019V11.3549Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M98.2019 13.1637H99.2798V14.2415H98.2019V13.1637Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M98.2019 16.7751H99.2798V17.853H98.2019V16.7751Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M99.9116 0.514404H100.99V1.59225H99.9116V0.514404Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M99.9116 5.93469H100.99V7.01254H99.9116V5.93469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M99.9116 7.74353H100.99V8.82138H99.9116V7.74353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M99.9116 9.54614H100.99V10.624H99.9116V9.54614Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M99.9116 11.3549H100.99V12.4327H99.9116V11.3549Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M99.9116 13.1637H100.99V14.2415H99.9116V13.1637Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M99.9116 16.7751H100.99V17.853H99.9116V16.7751Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M99.9116 18.5778H100.99V19.6556H99.9116V18.5778Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M115.441 -0.749268H116.519V0.328581H115.441V-0.749268Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M115.441 1.05334H116.519V2.1312H115.441V1.05334Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M115.441 2.86218H116.519V3.94003H115.441V2.86218Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M115.441 4.67102H116.519V5.74887H115.441V4.67102Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M115.441 6.47363H116.519V7.55149H115.441V6.47363Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M115.441 8.28235H116.519V9.3602H115.441V8.28235Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M115.441 13.7026H116.519V14.7805H115.441V13.7026Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M115.441 15.5052H116.519V16.5831H115.441V15.5052Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M115.441 17.3141H116.519V18.3919H115.441V17.3141Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M117.151 -0.749268H118.229V0.328581H117.151V-0.749268Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M117.151 1.05334H118.229V2.1312H117.151V1.05334Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M117.151 2.86218H118.229V3.94003H117.151V2.86218Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M117.151 4.67102H118.229V5.74887H117.151V4.67102Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M117.151 6.47363H118.229V7.55149H117.151V6.47363Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M117.151 8.28235H118.229V9.3602H117.151V8.28235Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M118.861 -0.749268H120.409V0.328581H118.861V-0.749268Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M118.861 1.05334H120.409V2.1312H118.861V1.05334Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M118.861 2.86218H120.409V3.94003H118.861V2.86218Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M118.861 4.67102H120.409V5.74887H118.861V4.67102Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M118.861 6.47363H120.409V7.55149H118.861V6.47363Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M118.861 8.28235H120.409V9.3602H118.861V8.28235Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M24.741 -0.210327H25.8188V0.867526H24.741V-0.210327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M24.741 1.59229H25.8188V2.67013H24.741V1.59229Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M24.741 3.40112H25.8188V4.47897H24.741V3.40112Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M24.741 5.20996H25.8188V6.28781H24.741V5.20996Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M24.741 7.01257H25.8188V8.09042H24.741V7.01257Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M24.741 8.82129H25.8188V9.89914H24.741V8.82129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M24.741 10.6239H25.8188V11.7017H24.741V10.6239Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M24.741 12.4327H25.8188V13.5106H24.741V12.4327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M24.741 14.2416H25.8188V15.3194H24.741V14.2416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M24.741 16.0442H25.8188V17.122H24.741V16.0442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M24.741 17.853H25.8188V18.9309H24.741V17.853Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M24.741 19.6555H25.8188V20.7334H24.741V19.6555Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M24.741 21.4644H25.8188V22.5422H24.741V21.4644Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M24.741 23.2732H25.8188V24.351H24.741V23.2732Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M24.741 25.0758H25.8188V26.1537H24.741V25.0758Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M24.741 26.8846H25.8188V27.9625H24.741V26.8846Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M24.741 28.6873H25.8188V29.7651H24.741V28.6873Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M24.741 30.496H25.8188V31.5738H24.741V30.496Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M24.741 32.3048H25.8188V33.3827H24.741V32.3048Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M24.741 34.1074H25.8188V35.1853H24.741V34.1074Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M26.4507 -0.210327H27.5286V0.867526H26.4507V-0.210327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M26.4507 1.59229H27.5286V2.67013H26.4507V1.59229Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M26.4507 3.40112H27.5286V4.47897H26.4507V3.40112Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M26.4507 5.20996H27.5286V6.28781H26.4507V5.20996Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M26.4507 7.01257H27.5286V8.09042H26.4507V7.01257Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M26.4507 8.82129H27.5286V9.89914H26.4507V8.82129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M26.4507 10.6239H27.5286V11.7017H26.4507V10.6239Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M26.4507 12.4327H27.5286V13.5106H26.4507V12.4327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M26.4507 14.2416H27.5286V15.3194H26.4507V14.2416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M26.4507 16.0442H27.5286V17.122H26.4507V16.0442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M26.4507 17.853H27.5286V18.9309H26.4507V17.853Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M26.4507 19.6555H27.5286V20.7334H26.4507V19.6555Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M26.4507 21.4644H27.5286V22.5422H26.4507V21.4644Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M26.4507 23.2732H27.5286V24.351H26.4507V23.2732Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M26.4507 25.0758H27.5286V26.1537H26.4507V25.0758Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M26.4507 26.8846H27.5286V27.9625H26.4507V26.8846Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M26.4507 28.6873H27.5286V29.7651H26.4507V28.6873Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M26.4507 30.496H27.5286V31.5738H26.4507V30.496Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M28.1665 -0.210327H29.2444V0.867526H28.1665V-0.210327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M28.1665 1.59229H29.2444V2.67013H28.1665V1.59229Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M28.1665 3.40112H29.2444V4.47897H28.1665V3.40112Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M28.1665 5.20996H29.2444V6.28781H28.1665V5.20996Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M28.1665 7.01257H29.2444V8.09042H28.1665V7.01257Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M28.1665 8.82129H29.2444V9.89914H28.1665V8.82129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M28.1665 10.6239H29.2444V11.7017H28.1665V10.6239Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M28.1665 12.4327H29.2444V13.5106H28.1665V12.4327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M28.1665 14.2416H29.2444V15.3194H28.1665V14.2416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M28.1665 16.0442H29.2444V17.122H28.1665V16.0442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M28.1665 17.853H29.2444V18.9309H28.1665V17.853Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M28.1665 19.6555H29.2444V20.7334H28.1665V19.6555Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M28.1665 21.4644H29.2444V22.5422H28.1665V21.4644Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M28.1665 23.2732H29.2444V24.351H28.1665V23.2732Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M28.1665 25.0758H29.2444V26.1537H28.1665V25.0758Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M28.1665 26.8846H29.2444V27.9625H28.1665V26.8846Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M28.1665 28.6873H29.2444V29.7651H28.1665V28.6873Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M28.1665 30.496H29.2444V31.5738H28.1665V30.496Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M18.3421 12.9717H19.4199V14.0495H18.3421V12.9717Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M18.3421 14.7805H19.4199V15.8584H18.3421V14.7805Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M18.3421 16.5831H19.4199V17.661H18.3421V16.5831Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M18.3421 18.3918H19.4199V19.4697H18.3421V18.3918Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M18.3421 20.1945H19.4199V21.2723H18.3421V20.1945Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M18.3421 22.0033H19.4199V23.0811H18.3421V22.0033Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M18.3421 23.8121H19.4199V24.89H18.3421V23.8121Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M18.3421 25.6147H19.4199V26.6926H18.3421V25.6147Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M18.3421 27.4236H19.4199V28.5014H18.3421V27.4236Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M18.3421 29.2261H19.4199V30.3039H18.3421V29.2261Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M18.3421 31.0349H19.4199V32.1128H18.3421V31.0349Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M18.3421 32.8438H19.4199V33.9216H18.3421V32.8438Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M18.3421 34.6464H19.4199V35.7242H18.3421V34.6464Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M20.0518 12.9717H21.1296V14.0495H20.0518V12.9717Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M20.0518 14.7805H21.1296V15.8584H20.0518V14.7805Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M20.0518 16.5831H21.1296V17.661H20.0518V16.5831Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M20.0518 18.3918H21.1296V19.4697H20.0518V18.3918Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M20.0518 20.1945H21.1296V21.2723H20.0518V20.1945Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M20.0518 22.0033H21.1296V23.0811H20.0518V22.0033Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M20.0518 23.8121H21.1296V24.89H20.0518V23.8121Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M20.0518 25.6147H21.1296V26.6926H20.0518V25.6147Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M20.0518 27.4236H21.1296V28.5014H20.0518V27.4236Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M20.0518 29.2261H21.1296V30.3039H20.0518V29.2261Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M20.0518 31.0349H21.1296V32.1128H20.0518V31.0349Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M20.0518 32.8438H21.1296V33.9216H20.0518V32.8438Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M20.0518 34.6464H21.1296V35.7242H20.0518V34.6464Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M21.7615 12.9717H22.8394V14.0495H21.7615V12.9717Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M21.7615 14.7805H22.8394V15.8584H21.7615V14.7805Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M21.7615 16.5831H22.8394V17.661H21.7615V16.5831Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M21.7615 18.3918H22.8394V19.4697H21.7615V18.3918Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M21.7615 20.1945H22.8394V21.2723H21.7615V20.1945Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M21.7615 22.0033H22.8394V23.0811H21.7615V22.0033Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M21.7615 23.8121H22.8394V24.89H21.7615V23.8121Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M21.7615 25.6147H22.8394V26.6926H21.7615V25.6147Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M21.7615 27.4236H22.8394V28.5014H21.7615V27.4236Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M21.7615 29.2261H22.8394V30.3039H21.7615V29.2261Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M21.7615 31.0349H22.8394V32.1128H21.7615V31.0349Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M21.7615 32.8438H22.8394V33.9216H21.7615V32.8438Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M21.7615 34.6464H22.8394V35.7242H21.7615V34.6464Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M21.7615 36.4552H22.8394V37.533H21.7615V36.4552Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M31.2701 13.5106H32.3479V14.5885H31.2701V13.5106Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M31.2701 15.3193H32.3479V16.3972H31.2701V15.3193Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M31.2701 17.1219H32.3479V18.1998H31.2701V17.1219Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M31.2701 18.9308H32.3479V20.0086H31.2701V18.9308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M31.2701 20.7334H32.3479V21.8113H31.2701V20.7334Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M31.2701 22.5422H32.3479V23.6201H31.2701V22.5422Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M31.2701 24.3511H32.3479V25.4289H31.2701V24.3511Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M31.2701 26.1537H32.3479V27.2315H31.2701V26.1537Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M31.2701 27.9624H32.3479V29.0403H31.2701V27.9624Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M31.2701 29.765H32.3479V30.8429H31.2701V29.765Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M31.2701 35.1853H32.3479V36.2631H31.2701V35.1853Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M32.9798 13.5106H34.0576V14.5885H32.9798V13.5106Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M32.9798 15.3193H34.0576V16.3972H32.9798V15.3193Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M32.9798 17.1219H34.0576V18.1998H32.9798V17.1219Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M32.9798 18.9308H34.0576V20.0086H32.9798V18.9308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M32.9798 20.7334H34.0576V21.8113H32.9798V20.7334Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M32.9798 22.5422H34.0576V23.6201H32.9798V22.5422Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M32.9798 24.3511H34.0576V25.4289H32.9798V24.3511Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M32.9798 26.1537H34.0576V27.2315H32.9798V26.1537Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M32.9798 27.9624H34.0576V29.0403H32.9798V27.9624Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M32.9798 33.3827H34.0576V34.4605H32.9798V33.3827Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M32.9798 35.1853H34.0576V36.2631H32.9798V35.1853Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M34.6956 13.5106H35.7734V14.5885H34.6956V13.5106Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M34.6956 15.3193H35.7734V16.3972H34.6956V15.3193Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M34.6956 17.1219H35.7734V18.1998H34.6956V17.1219Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M34.6956 18.9308H35.7734V20.0086H34.6956V18.9308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M34.6956 20.7334H35.7734V21.8113H34.6956V20.7334Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M34.6956 22.5422H35.7734V23.6201H34.6956V22.5422Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M34.6956 24.3511H35.7734V25.4289H34.6956V24.3511Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M34.6956 26.1537H35.7734V27.2315H34.6956V26.1537Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M34.6956 31.5739H35.7734V32.6517H34.6956V31.5739Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M34.6956 33.3827H35.7734V34.4605H34.6956V33.3827Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M34.6956 35.1853H35.7734V36.2631H34.6956V35.1853Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M50.603 0.514404H51.6809V1.59225H50.603V0.514404Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M50.603 2.32324H51.6809V3.40109H50.603V2.32324Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M50.603 4.13208H51.6809V5.20993H50.603V4.13208Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M50.603 5.93469H51.6809V7.01254H50.603V5.93469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M50.603 7.74353H51.6809V8.82138H50.603V7.74353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M50.603 9.54614H51.6809V10.624H50.603V9.54614Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M50.603 11.3549H51.6809V12.4327H50.603V11.3549Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M50.603 13.1637H51.6809V14.2415H50.603V13.1637Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M50.603 14.9663H51.6809V16.0442H50.603V14.9663Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M50.603 18.5778H51.6809V19.6556H50.603V18.5778Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M50.603 20.3865H51.6809V21.4643H50.603V20.3865Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M50.603 22.1953H51.6809V23.2732H50.603V22.1953Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M50.603 23.9979H51.6809V25.0758H50.603V23.9979Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M50.603 25.8068H51.6809V26.8846H50.603V25.8068Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M52.3128 0.514404H53.3906V1.59225H52.3128V0.514404Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M52.3128 2.32324H53.3906V3.40109H52.3128V2.32324Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M52.3128 4.13208H53.3906V5.20993H52.3128V4.13208Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M52.3128 5.93469H53.3906V7.01254H52.3128V5.93469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M52.3128 7.74353H53.3906V8.82138H52.3128V7.74353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M52.3128 9.54614H53.3906V10.624H52.3128V9.54614Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M52.3128 11.3549H53.3906V12.4327H52.3128V11.3549Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M52.3128 13.1637H53.3906V14.2415H52.3128V13.1637Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M52.3128 23.9979H53.3906V25.0758H52.3128V23.9979Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M52.3128 25.8068H53.3906V26.8846H52.3128V25.8068Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M54.0225 0.514404H55.1003V1.59225H54.0225V0.514404Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M54.0225 2.32324H55.1003V3.40109H54.0225V2.32324Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M54.0225 4.13208H55.1003V5.20993H54.0225V4.13208Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M54.0225 5.93469H55.1003V7.01254H54.0225V5.93469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M54.0225 7.74353H55.1003V8.82138H54.0225V7.74353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M54.0225 9.54614H55.1003V10.624H54.0225V9.54614Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M54.0225 11.3549H55.1003V12.4327H54.0225V11.3549Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M54.0225 13.1637H55.1003V14.2415H54.0225V13.1637Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M54.0225 16.7751H55.1003V17.853H54.0225V16.7751Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M54.0225 18.5778H55.1003V19.6556H54.0225V18.5778Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M54.0225 20.3865H55.1003V21.4643H54.0225V20.3865Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M54.0225 22.1953H55.1003V23.2732H54.0225V22.1953Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M54.0225 25.8068H55.1003V26.8846H54.0225V25.8068Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M44.3899 8.82129H45.4678V9.89914H44.3899V8.82129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M44.3899 10.6239H45.4678V11.7017H44.3899V10.6239Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M44.3899 12.4327H45.4678V13.5106H44.3899V12.4327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M44.3899 14.2416H45.4678V15.3194H44.3899V14.2416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M44.3899 16.0442H45.4678V17.122H44.3899V16.0442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M44.3899 17.853H45.4678V18.9309H44.3899V17.853Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M44.3899 19.6555H45.4678V20.7334H44.3899V19.6555Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M44.3899 23.2732H45.4678V24.351H44.3899V23.2732Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M44.3899 25.0758H45.4678V26.1537H44.3899V25.0758Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M44.3899 26.8846H45.4678V27.9625H44.3899V26.8846Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M44.3899 28.6873H45.4678V29.7651H44.3899V28.6873Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M44.3899 30.496H45.4678V31.5738H44.3899V30.496Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M44.3899 32.3048H45.4678V33.3827H44.3899V32.3048Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M44.3899 34.1074H45.4678V35.1853H44.3899V34.1074Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M44.3899 35.9163H45.4678V36.9941H44.3899V35.9163Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M46.0996 8.82129H47.1775V9.89914H46.0996V8.82129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M46.0996 10.6239H47.1775V11.7017H46.0996V10.6239Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M46.0996 12.4327H47.1775V13.5106H46.0996V12.4327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M46.0996 14.2416H47.1775V15.3194H46.0996V14.2416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M46.0996 16.0442H47.1775V17.122H46.0996V16.0442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M46.0996 17.853H47.1775V18.9309H46.0996V17.853Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M46.0996 23.2732H47.1775V24.351H46.0996V23.2732Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M46.0996 25.0758H47.1775V26.1537H46.0996V25.0758Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M46.0996 26.8846H47.1775V27.9625H46.0996V26.8846Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M46.0996 28.6873H47.1775V29.7651H46.0996V28.6873Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M46.0996 30.496H47.1775V31.5738H46.0996V30.496Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M46.0996 32.3048H47.1775V33.3827H46.0996V32.3048Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M46.0996 34.1074H47.1775V35.1853H46.0996V34.1074Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M46.0996 35.9163H47.1775V36.9941H46.0996V35.9163Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M47.8157 8.82129H48.8936V9.89914H47.8157V8.82129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M47.8157 10.6239H48.8936V11.7017H47.8157V10.6239Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M47.8157 12.4327H48.8936V13.5106H47.8157V12.4327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M47.8157 14.2416H48.8936V15.3194H47.8157V14.2416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M47.8157 16.0442H48.8936V17.122H47.8157V16.0442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M47.8157 17.853H48.8936V18.9309H47.8157V17.853Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M47.8157 21.4644H48.8936V22.5422H47.8157V21.4644Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M47.8157 23.2732H48.8936V24.351H47.8157V23.2732Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M47.8157 25.0758H48.8936V26.1537H47.8157V25.0758Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M47.8157 26.8846H48.8936V27.9625H47.8157V26.8846Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M47.8157 28.6873H48.8936V29.7651H47.8157V28.6873Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M47.8157 30.496H48.8936V31.5738H47.8157V30.496Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M47.8157 32.3048H48.8936V33.3827H47.8157V32.3048Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M47.8157 34.1074H48.8936V35.1853H47.8157V34.1074Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M47.8157 35.9163H48.8936V36.9941H47.8157V35.9163Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M83.8741 0.514404H84.9519V1.59225H83.8741V0.514404Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M83.8741 2.32324H84.9519V3.40109H83.8741V2.32324Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M83.8741 4.13208H84.9519V5.20993H83.8741V4.13208Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M83.8741 5.93469H84.9519V7.01254H83.8741V5.93469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M83.8741 7.74353H84.9519V8.82138H83.8741V7.74353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M83.8741 9.54614H84.9519V10.624H83.8741V9.54614Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M83.8741 11.3549H84.9519V12.4327H83.8741V11.3549Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M83.8741 13.1637H84.9519V14.2415H83.8741V13.1637Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M83.8741 14.9663H84.9519V16.0442H83.8741V14.9663Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M83.8741 16.7751H84.9519V17.853H83.8741V16.7751Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M83.8741 18.5778H84.9519V19.6556H83.8741V18.5778Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M83.8741 20.3865H84.9519V21.4643H83.8741V20.3865Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M83.8741 23.9979H84.9519V25.0758H83.8741V23.9979Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M83.8741 25.8068H84.9519V26.8846H83.8741V25.8068Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M83.8741 27.6094H84.9519V28.6872H83.8741V27.6094Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M83.8741 29.4182H84.9519V30.4961H83.8741V29.4182Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M83.8741 33.0295H84.9519V34.1074H83.8741V33.0295Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M83.8741 34.8384H84.9519V35.9162H83.8741V34.8384Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M83.8741 36.6472H84.9519V37.7251H83.8741V36.6472Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M85.5899 0.514404H86.6677V1.59225H85.5899V0.514404Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M85.5899 2.32324H86.6677V3.40109H85.5899V2.32324Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M85.5899 4.13208H86.6677V5.20993H85.5899V4.13208Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M85.5899 5.93469H86.6677V7.01254H85.5899V5.93469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M85.5899 7.74353H86.6677V8.82138H85.5899V7.74353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M85.5899 9.54614H86.6677V10.624H85.5899V9.54614Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M85.5899 11.3549H86.6677V12.4327H85.5899V11.3549Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M85.5899 13.1637H86.6677V14.2415H85.5899V13.1637Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M85.5899 14.9663H86.6677V16.0442H85.5899V14.9663Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M85.5899 16.7751H86.6677V17.853H85.5899V16.7751Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M85.5899 18.5778H86.6677V19.6556H85.5899V18.5778Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M85.5899 20.3865H86.6677V21.4643H85.5899V20.3865Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M85.5899 25.8068H86.6677V26.8846H85.5899V25.8068Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M85.5899 27.6094H86.6677V28.6872H85.5899V27.6094Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M85.5899 31.2269H86.6677V32.3048H85.5899V31.2269Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M85.5899 33.0295H86.6677V34.1074H85.5899V33.0295Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M85.5899 34.8384H86.6677V35.9162H85.5899V34.8384Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M85.5899 36.6472H86.6677V37.7251H85.5899V36.6472Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M87.2996 0.514404H88.3774V1.59225H87.2996V0.514404Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M87.2996 2.32324H88.3774V3.40109H87.2996V2.32324Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M87.2996 4.13208H88.3774V5.20993H87.2996V4.13208Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    d: "M87.2996 5.93469H88.3774V7.01254H87.2996V5.93469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    d: "M87.2996 7.74353H88.3774V8.82138H87.2996V7.74353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    d: "M87.2996 9.54614H88.3774V10.624H87.2996V9.54614Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    d: "M87.2996 11.3549H88.3774V12.4327H87.2996V11.3549Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    d: "M87.2996 13.1637H88.3774V14.2415H87.2996V13.1637Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    d: "M87.2996 14.9663H88.3774V16.0442H87.2996V14.9663Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    d: "M87.2996 16.7751H88.3774V17.853H87.2996V16.7751Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    d: "M87.2996 18.5778H88.3774V19.6556H87.2996V18.5778Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    d: "M87.2996 20.3865H88.3774V21.4643H87.2996V20.3865Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    d: "M87.2996 22.1953H88.3774V23.2732H87.2996V22.1953Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    d: "M87.2996 25.8068H88.3774V26.8846H87.2996V25.8068Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    d: "M87.2996 29.4182H88.3774V30.4961H87.2996V29.4182Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    d: "M87.2996 31.2269H88.3774V32.3048H87.2996V31.2269Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    d: "M87.2996 33.0295H88.3774V34.1074H87.2996V33.0295Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    d: "M87.2996 34.8384H88.3774V35.9162H87.2996V34.8384Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    d: "M87.2996 36.6472H88.3774V37.7251H87.2996V36.6472Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    d: "M76.9051 9.0072H77.9829V10.0851H76.9051V9.0072Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    d: "M76.9051 10.8159H77.9829V11.8938H76.9051V10.8159Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    d: "M76.9051 12.6248H77.9829V13.7026H76.9051V12.6248Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    d: "M76.9051 14.4274H77.9829V15.5052H76.9051V14.4274Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    d: "M76.9051 16.2362H77.9829V17.3141H76.9051V16.2362Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    d: "M76.9051 18.0388H77.9829V19.1167H76.9051V18.0388Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_366",
    d: "M76.9051 23.459H77.9829V24.5368H76.9051V23.459Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_367",
    d: "M76.9051 25.2678H77.9829V26.3457H76.9051V25.2678Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_368",
    d: "M76.9051 27.0704H77.9829V28.1483H76.9051V27.0704Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_369",
    d: "M76.9051 28.8793H77.9829V29.9571H76.9051V28.8793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_370",
    d: "M76.9051 30.688H77.9829V31.7658H76.9051V30.688Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_371",
    d: "M76.9051 32.4907H77.9829V33.5686H76.9051V32.4907Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_372",
    d: "M76.9051 34.2994H77.9829V35.3773H76.9051V34.2994Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_373",
    d: "M78.6148 9.0072H79.6926V10.0851H78.6148V9.0072Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_374",
    d: "M78.6148 10.8159H79.6926V11.8938H78.6148V10.8159Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_375",
    d: "M78.6148 12.6248H79.6926V13.7026H78.6148V12.6248Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_376",
    d: "M78.6148 14.4274H79.6926V15.5052H78.6148V14.4274Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_377",
    d: "M78.6148 16.2362H79.6926V17.3141H78.6148V16.2362Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_378",
    d: "M78.6148 18.0388H79.6926V19.1167H78.6148V18.0388Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_379",
    d: "M78.6148 23.459H79.6926V24.5368H78.6148V23.459Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_380",
    d: "M78.6148 25.2678H79.6926V26.3457H78.6148V25.2678Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_381",
    d: "M78.6148 27.0704H79.6926V28.1483H78.6148V27.0704Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_382",
    d: "M78.6148 28.8793H79.6926V29.9571H78.6148V28.8793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_383",
    d: "M78.6148 30.688H79.6926V31.7658H78.6148V30.688Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_384",
    d: "M78.6148 32.4907H79.6926V33.5686H78.6148V32.4907Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_385",
    d: "M78.6148 36.1083H79.6926V37.1861H78.6148V36.1083Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_386",
    d: "M118.57 -50.0577H120.707V67.3226H118.57V-50.0577Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_387",
    d: "M84.5493 -50.0577H86.3582V67.3226H84.5493V-50.0577Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_388",
    d: "M50.5288 -50.0577H52.3376V67.3226H50.5288V-50.0577Z",
    fill: "#EBEBEB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_389",
    d: "M229.471 97.1121C229.471 97.1121 232.233 91.0849 229.074 85.1381C225.915 79.1913 224.998 77.7914 227.011 76.5772C229.025 75.3569 229.948 81.3347 229.948 81.3347C229.948 81.3347 231.645 77.2277 230.245 72.9225C228.845 68.6235 227.965 61.6174 229.879 60.8679C231.793 60.1184 230.245 69.6084 231.905 72.8419C231.905 72.8419 233.299 69.2429 233.528 65.7864C233.757 62.3298 233.398 56.8167 234.909 55.4043C236.421 53.992 237.387 54.9707 235.9 62.59C234.414 70.2155 234.426 76.41 234.426 76.41C234.426 76.41 237.703 66.412 239.908 66.1209C242.107 65.8297 242.107 69.0695 240.224 71.8756C238.341 74.6817 234.705 79.7179 234.11 82.3072C234.11 82.3072 237.709 74.7808 240.949 77.0914C244.189 79.3958 238.13 83.9426 235.43 85.5841C232.729 87.2257 230.858 97.521 230.858 97.521L229.471 97.1245V97.1121Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_390",
    d: "M231.651 99.5837C231.651 99.5837 228.963 93.5131 232.19 87.6159C235.417 81.7187 236.353 80.3311 234.352 79.086C232.351 77.8409 231.36 83.8 231.36 83.8C231.36 83.8 229.712 79.6683 231.168 75.3879C232.617 71.1074 233.584 64.12 231.676 63.3395C229.774 62.559 231.205 72.0738 229.508 75.2826C229.508 75.2826 228.157 71.6588 227.971 68.2022C227.786 64.7456 228.207 59.2325 226.714 57.7954C225.221 56.3582 224.242 57.3246 225.636 64.9686C227.03 72.6127 226.943 78.8072 226.943 78.8072C226.943 78.8072 223.784 68.7597 221.585 68.4376C219.386 68.1155 219.349 71.349 221.201 74.1861C223.053 77.0232 226.621 82.1089 227.191 84.7045C227.191 84.7045 223.679 77.1285 220.414 79.3833C217.15 81.6381 223.152 86.2779 225.828 87.9566C228.51 89.6415 230.257 99.9616 230.257 99.9616L231.651 99.5837Z",
    fill: "#EBEBEB"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Board"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_391",
    d: "M134.248 -20.6771H228.938V42.8665H134.248V-20.6771Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_392",
    d: "M207.548 14.3593H210.435V125.062L216.747 126.406V127.515H209.512H208.477H201.242V126.406L207.548 125.062V14.3593Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_393",
    d: "M152.751 125.062V14.3593H155.638V125.062L161.95 126.406V127.515H154.709H153.68H146.445V126.406L152.751 125.062Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_394",
    d: "M134.248 -20.6771H228.938V42.8665H134.248V-20.6771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_395",
    d: "M207.548 14.3593H210.435V125.062L216.747 126.406V127.515H209.512H208.477H201.242V126.406L207.548 125.062V14.3593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_396",
    d: "M152.751 125.062V14.3593H155.638V125.062L161.95 126.406V127.515H154.709H153.68H146.445V126.406L152.751 125.062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_397",
    d: "M136.986 40.1284V-17.933L226.2 -17.933V40.1284L136.986 40.1284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_398",
    d: "M143.763 36.0091H220.774V-7.16687H220.154V35.3896H143.763V36.0091Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_399",
    opacity: 0.2,
    d: "M213.421 28.842H216.747V35.0799H213.421V28.842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_400",
    d: "M213.421 28.842H216.747V30.657H213.421V28.842Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_401",
    opacity: 0.2,
    d: "M206.625 18.8689H209.952V35.08H206.625V18.8689Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_402",
    d: "M206.625 18.8689H209.952V23.5891H206.625V18.8689Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_403",
    opacity: 0.2,
    d: "M199.83 22.6104H203.156V35.0862H199.83V22.6104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_404",
    d: "M199.83 22.6104H203.156V26.2404H199.83V22.6104Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_405",
    opacity: 0.2,
    d: "M193.035 16.8743H196.361V35.08H193.035V16.8743Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_406",
    d: "M193.035 16.8743H196.361V22.1768H193.035V16.8743Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_407",
    opacity: 0.2,
    d: "M186.239 11.5779H189.566V35.08H186.239V11.5779Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_408",
    d: "M186.239 11.5779H189.566V18.4228H186.239V11.5779Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_409",
    opacity: 0.2,
    d: "M179.444 7.57617H182.77V35.0799H179.444V7.57617Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_410",
    d: "M179.444 7.57617H182.77V15.5857H179.444V7.57617Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_411",
    opacity: 0.2,
    d: "M172.648 12.2036H175.975V35.0801H172.648V12.2036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_412",
    d: "M172.648 12.2036H175.975V18.8627H172.648V12.2036Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_413",
    opacity: 0.2,
    d: "M165.847 11.2062H169.173V35.0799H165.847V11.2062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_414",
    d: "M165.847 11.2062H169.173V18.1565H165.847V11.2062Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_415",
    opacity: 0.2,
    d: "M159.051 5.11694H162.378V35.0799H159.051V5.11694Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_416",
    d: "M159.051 5.11694H162.378V13.8389H159.051V5.11694Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_417",
    opacity: 0.2,
    d: "M152.256 -1.02185H155.583V35.0799H152.256V-1.02185Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_418",
    d: "M152.256 -1.02185H155.583V9.49028H152.256V-1.02185Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_419",
    opacity: 0.2,
    d: "M145.461 -6.39246H148.787V35.08H145.461V-6.39246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_420",
    d: "M145.461 -6.39246H148.787V5.6807H145.461V-6.39246Z",
    fill: "#407BFF"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Character 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_421",
    d: "M138.095 28.5881L140.976 27.1757C140.976 27.1757 141.83 25.2802 141.892 25.3112C141.954 25.3421 147.405 24.1899 147.405 24.1899C147.405 24.1899 147.467 27.4111 146.854 28.0925C146.241 28.7739 142.506 29.096 142.32 29.2137C142.134 29.3314 141.706 28.9473 141.706 28.9473L138.646 30.9606L138.095 28.6005V28.5881Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_422",
    d: "M106.627 4.35508C106.627 4.35508 107.822 1.59851 111.682 1.59851C115.541 1.59851 118.756 3.89668 118.576 6.83909C118.396 9.7815 120.595 9.50274 120.967 12.3522C121.339 15.2017 119.957 15.9389 119.864 17.1282C119.772 18.3238 121.333 17.9583 122.349 19.9777C123.358 21.9971 124.647 24.8466 120.329 28.6129C116.011 32.3792 103.79 31.7349 101.126 29.443C98.4624 27.1448 98.5553 22.7343 101.126 21.5387C103.697 20.3432 101.312 20.529 101.033 17.8654C100.761 15.2017 103.145 14.192 102.966 12.0735C102.786 9.95494 102.136 4.54092 106.639 4.35508H106.627Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_423",
    d: "M121.624 22.2325V29.8084C121.624 29.8084 122.274 30.6199 123.247 31.6606C124.164 32.6455 125.384 33.8349 126.604 34.7207C127.769 35.5632 128.933 36.1393 129.887 36.0154C132.886 35.6313 140.976 30.9792 140.976 30.9792L139.631 27.405C139.631 27.405 130.445 32.1314 129.887 31.642C129.336 31.1526 123.296 22.6599 121.63 22.2263L121.624 22.2325Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_424",
    opacity: 0.2,
    d: "M123.247 31.6668C124.164 32.6518 125.384 33.8411 126.604 34.7269C127.044 31.3447 123.16 27.1758 123.16 27.1758C123.16 27.1758 123.104 29.3439 123.247 31.6668Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_425",
    d: "M120.565 49.6743C120.565 49.6743 125.601 76.5091 126.945 87.5291C128.698 101.9 135.877 122.931 135.877 122.931L133.009 123.674C133.009 123.674 122.887 105.803 120.918 89.7282C112.877 73.2941 112.233 53.0627 112.233 53.0627L120.571 49.6805L120.565 49.6743Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_426",
    d: "M115.33 49.2469C115.33 49.2469 114.704 76.5463 113.738 87.6035C112.481 102.031 115.157 124.089 115.157 124.089L112.196 124.219C112.196 124.219 105.989 104.645 107.389 88.5079C102.922 70.7668 106.472 50.8389 106.472 50.8389L115.33 49.2531V49.2469Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_427",
    d: "M122.287 45.1957C122.287 45.1957 124.281 65.0615 127.242 84.977C129.937 103.108 135.208 118.427 135.208 118.427L129.33 118.917C129.33 118.917 118.056 90.9795 114.624 74.8055C114.624 74.8055 113.398 103.474 115.361 119.406L110.214 119.158C110.214 119.158 97.6572 65.204 107.03 45.7656L122.293 45.1895L122.287 45.1957Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_428",
    opacity: 0.4,
    d: "M110.208 119.17L115.356 119.412C113.398 103.486 114.618 74.8112 114.618 74.8112C115.486 78.8934 116.855 83.7189 118.409 88.6621C123.024 103.3 129.324 118.922 129.324 118.922L135.203 118.427C135.203 118.427 129.938 103.114 127.243 84.9764C124.282 65.0609 122.287 45.1951 122.287 45.1951L107.024 45.7712C97.6516 65.2034 110.208 119.164 110.208 119.164V119.17Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_429",
    d: "M107.054 44.8116L107.017 47.054L122.367 46.1682L122.417 43.5107L107.054 44.8116Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_430",
    d: "M119.045 46.5462L115.69 46.7826L115.511 44.2368L118.866 44.0004L119.045 46.5462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_431",
    d: "M112.351 47.8432L111.59 47.8677L111.465 43.9919L112.227 43.9674L112.351 47.8432Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_432",
    opacity: 0.4,
    d: "M112.351 47.8432L111.59 47.8677L111.465 43.9919L112.227 43.9674L112.351 47.8432Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_433",
    d: "M121.725 46.9857L120.963 47.0101L120.839 43.1344L121.6 43.1099L121.725 46.9857Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_434",
    opacity: 0.4,
    d: "M121.725 46.9857L120.963 47.0101L120.839 43.1344L121.6 43.1099L121.725 46.9857Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_435",
    d: "M122.386 43.7957L107.06 44.8054C106.819 40.9958 106.546 39.825 105.394 35.2844C105.029 33.8163 104.564 32.1748 103.975 30.2793C103.66 29.2634 103.313 28.1793 102.922 27.0085C102.631 26.1227 102.315 25.1811 101.962 24.1838C104.05 23.521 106.168 23.0007 108.324 22.6476C110.597 22.2449 112.902 22.0033 115.206 21.9228C118.186 21.898 121.618 22.2325 121.618 22.2325C121.618 22.2325 122.107 22.3502 122.41 25.5095C122.689 28.4766 122.987 32.9925 122.373 43.7895L122.386 43.7957Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_436",
    opacity: 0.4,
    d: "M122.386 43.7957L107.06 44.8054C106.819 40.9958 106.546 39.825 105.394 35.2844C105.029 33.8163 104.564 32.1748 103.975 30.2793C103.66 29.2634 103.313 28.1793 102.922 27.0085C102.631 26.1227 102.315 25.1811 101.962 24.1838C104.05 23.521 106.168 23.0007 108.324 22.6476C110.597 22.2449 112.902 22.0033 115.206 21.9228C118.186 21.898 121.618 22.2325 121.618 22.2325C121.618 22.2325 122.107 22.3502 122.41 25.5095C122.689 28.4766 122.987 32.9925 122.373 43.7895L122.386 43.7957Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_437",
    d: "M113.949 25.3112C110.17 24.828 109.037 23.2112 109.037 23.2112C111.434 20.9502 109.439 17.0291 109.439 17.0291L113.986 17.8777C113.868 18.6272 113.813 19.2591 113.806 19.7918C113.769 22.5546 115.02 22.5794 115.02 22.5794C115.82 24.0722 113.943 25.305 113.943 25.305L113.949 25.3112Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_438",
    opacity: 0.2,
    d: "M113.986 17.8777C113.868 18.6272 113.812 19.2591 113.806 19.7918C110.734 19.7918 109.433 17.0291 109.433 17.0291L113.98 17.8777H113.986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_439",
    d: "M111.471 5.16048C115.423 4.94367 116.817 6.99406 117.325 11.0515C117.963 16.1248 117.034 19.8044 112.029 18.9867C105.233 17.8779 104.899 5.51976 111.465 5.16048H111.471Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_440",
    d: "M114.76 10.9709C114.76 10.9709 115.367 11.9745 115.999 12.5506C115.999 12.5506 115.69 13.1081 114.983 13.0523L114.76 10.9709Z",
    fill: "#D58745"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_441",
    d: "M112.326 10.7788C112.351 11.1009 112.196 11.3797 111.979 11.3983C111.762 11.4168 111.564 11.1629 111.539 10.8407C111.514 10.5186 111.669 10.2399 111.886 10.2213C112.103 10.2027 112.301 10.4567 112.326 10.7788Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_442",
    d: "M111.799 10.2461L112.481 9.91162C112.481 9.91162 112.177 10.5311 111.799 10.2461Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_443",
    d: "M116.352 10.3948C116.377 10.7169 116.222 10.9956 116.005 11.0142C115.788 11.0328 115.59 10.7788 115.565 10.4567C115.541 10.1346 115.696 9.85585 115.912 9.83726C116.129 9.81868 116.327 10.0727 116.352 10.3948Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_444",
    d: "M115.826 9.86209L116.507 9.52759C116.507 9.52759 116.204 10.147 115.826 9.86209Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_445",
    d: "M112.134 8.04706C112.134 8.04706 111.013 7.96033 110.449 8.74085",
    stroke: "#2E353A",
    strokeWidth: 0.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_446",
    d: "M115.002 7.72501C115.002 7.72501 115.683 7.42768 116.594 7.9666",
    stroke: "#2E353A",
    strokeWidth: 0.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_447",
    d: "M114.494 14.6381C114.289 15.1274 114.11 16.038 114.11 16.038C114.023 16.038 113.936 16.038 113.856 16.0256C112.697 15.9699 112.177 15.5672 111.954 15.1274C111.83 14.892 111.799 14.6381 111.799 14.4337C111.799 14.1983 111.849 14.031 111.849 14.031C112.444 14.4275 113.521 14.5575 114.097 14.6071C114.339 14.6319 114.494 14.6319 114.494 14.6319V14.6381Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_448",
    d: "M114.097 14.6133L113.974 15.0222C112.883 14.9664 112.121 14.7868 111.799 14.4399C111.799 14.2045 111.849 14.0372 111.849 14.0372C112.443 14.4337 113.521 14.5638 114.097 14.6133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_449",
    d: "M113.85 16.0257C112.691 15.9699 112.171 15.5673 111.948 15.1274C112.344 15.1584 112.815 15.2451 113.224 15.4434C113.54 15.592 113.726 15.8088 113.85 16.0257Z",
    fill: "#DE5753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_450",
    d: "M107.519 12.0611C107.519 12.0611 109.192 8.70987 108.77 6.21967C108.77 6.21967 116.433 2.58967 117.251 10.5187C117.251 10.5187 117.628 3.41354 110.821 3.63035C104.025 3.84716 104.589 13.7894 108.262 16.5584C108.262 16.5584 106.478 14.1549 107.513 12.0611H107.519Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_451",
    d: "M107.116 4.78256C107.116 4.78256 110.207 2.02599 113.026 2.54634C115.844 3.06668 115.355 6.77101 111.644 8.18337C107.934 9.59572 107.172 11.3983 107.172 11.3983L103.957 8.51787L107.11 4.78256H107.116Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_452",
    d: "M113.856 3.70471C113.856 3.70471 115.175 3.79763 114.804 5.75511C114.438 7.71258 111.651 8.70371 109.012 9.6205C106.379 10.5373 106.59 11.578 106.59 11.578",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_453",
    d: "M108.206 12.8603C108.144 12.2223 107.432 11.1816 106.255 11.3798C105.035 11.578 104.589 14.1302 107.674 14.5638C108.113 14.6257 108.337 14.1859 108.213 12.8603H108.206Z",
    fill: "#EBB376"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_454",
    d: "M105.53 23.6324C105.53 23.6324 109.966 27.2315 114.097 27.1757C118.229 27.12 119.679 22.4741 119.679 22.4741C119.679 22.4741 113.274 20.5785 105.53 23.6386V23.6324Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_455",
    d: "M101.962 24.1831L103.957 48.1064L108.237 48.4657C108.869 45.2136 108.981 40.0783 108.9 35.2342C108.789 28.6618 108.324 22.6469 108.324 22.6469C105.945 22.9008 101.962 24.1831 101.962 24.1831Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_456",
    opacity: 0.4,
    d: "M107.643 28.6501L106.485 30.4217L108.901 35.2225C108.789 28.6563 108.325 22.6414 108.325 22.6414L104.639 26.0669L107.643 28.6377V28.6501Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_457",
    d: "M116.594 21.8856C116.693 22.0653 118.824 25.943 120.521 33.3641C121.364 37.0499 122.095 41.6214 122.41 47.0478L124.046 46.2921C124.046 46.2921 124.814 27.7642 121.624 22.2325L116.594 21.8856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_458",
    opacity: 0.4,
    d: "M116.6 21.8918C116.699 22.0653 118.83 25.9431 120.527 33.3641L121.289 28.582L119.685 27.1696L121.289 24.1157L116.6 21.8918Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_459",
    d: "M95.7617 38.6356C96.2386 39.6639 97.0625 39.7568 97.905 39.3418C98.574 39.0135 99.2616 38.3507 99.8005 37.5763C100.185 37.025 100.699 36.195 101.231 35.3153C102.365 33.4136 103.542 31.3075 103.542 31.3075L101.956 24.1899C99.6766 25.2802 94.9006 36.7958 95.7555 38.6356H95.7617Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_460",
    opacity: 0.2,
    d: "M97.905 39.3418C98.574 39.0135 99.2616 38.3507 99.8005 37.5763C100.185 37.025 100.699 36.195 101.231 35.3153C100.581 34.1198 99.8872 33.1782 99.8872 33.1782L98.735 36.418C98.735 36.418 96.7156 36.8764 96.3935 37.9356C96.2758 38.3321 96.9634 38.902 97.905 39.348V39.3418Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_461",
    d: "M97.9793 30.0872L101.795 44.632C101.882 44.9727 102.241 45.2143 102.594 45.1647L112.722 43.8143C113.075 43.7647 113.286 43.4488 113.193 43.1081L109.377 28.5634C109.291 28.2227 108.931 27.9811 108.578 28.0306L98.4501 29.381C98.097 29.4306 97.8864 29.7465 97.9793 30.0872Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_462",
    opacity: 0.1,
    d: "M97.9793 30.0871L101.795 44.6319C101.882 44.9726 102.241 45.2142 102.594 45.1647L112.258 43.8762C112.611 43.8266 112.821 43.5107 112.729 43.17L108.913 28.6252C108.826 28.2845 108.467 28.043 108.114 28.0925L98.4501 29.381C98.097 29.4305 97.8864 29.7464 97.9793 30.0871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_463",
    opacity: 0.3,
    d: "M105.004 35.6314C105.506 35.5632 106.02 35.9101 106.15 36.3995C106.28 36.8888 105.977 37.341 105.475 37.4092C104.973 37.4773 104.459 37.1304 104.329 36.6411C104.831 36.5729 105.134 36.1207 105.004 35.6314Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_464",
    d: "M97.1553 42.0613C97.8367 42.4206 99.3729 41.8755 99.8437 41.6896C99.9367 41.6586 99.9862 41.6339 99.9862 41.6339C99.9862 41.6339 100.829 38.8959 98.6358 37.4092C98.6234 37.403 98.6048 37.3844 98.5862 37.3782C97.8925 37.0003 95.7306 37.4835 95.6624 38.2145C95.4022 41.1383 96.3376 41.6277 97.1491 42.0551L97.1553 42.0613Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_465",
    opacity: 0.2,
    d: "M98.4871 39.7197C98.7535 40.7108 99.3358 41.3241 99.8437 41.6896C99.9367 41.6586 99.9862 41.6338 99.9862 41.6338C99.9862 41.6338 100.829 38.8958 98.6358 37.4091C98.6234 37.403 98.6048 37.3844 98.5862 37.3782C98.3942 37.626 98.0969 38.2764 98.4809 39.7135L98.4871 39.7197Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_466",
    d: "M101.64 36.2446C101.64 36.2446 100.234 36.1826 99.5898 36.2446C98.9456 36.3065 99.1438 38.3817 99.1438 38.3817L98.5925 38.679C98.5925 38.679 98.1403 39.8994 99.1066 40.5126L99.6022 40.3454C99.6022 40.3454 99.7447 40.8347 100.141 41.0825C100.538 41.3303 102.501 40.779 102.501 40.779L101.646 36.2446H101.64Z",
    fill: "#EBB376"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_467",
    d: "M158.76 56.6308H178.663L175.361 43.5727C175.287 43.2878 174.99 43.0586 174.686 43.0586H155.873C155.576 43.0586 155.39 43.2878 155.458 43.5727L158.76 56.6308Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_468",
    d: "M158.909 55.5406H177.963L175.064 44.0807H156.01L158.909 55.5406Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_469",
    opacity: 0.6,
    d: "M158.909 55.5406H177.963L175.064 44.0807H156.01L158.909 55.5406Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_470",
    d: "M167.432 56.2096H187.36V57.0397C187.36 57.3927 187.075 57.6839 186.716 57.6839H159.404C159.051 57.6839 158.76 57.3989 158.76 57.0397V56.2096H167.432Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_471",
    opacity: 0.6,
    d: "M167.432 56.2096H187.36V57.0397C187.36 57.3927 187.075 57.6839 186.716 57.6839H159.404C159.051 57.6839 158.76 57.3989 158.76 57.0397V56.2096H167.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_472",
    opacity: 0.2,
    d: "M176.761 56.2096V56.4945H180.23V56.2096H187.354V57.0397C187.354 57.3927 187.069 57.6839 186.71 57.6839H168.07C167.717 57.6839 167.426 57.3989 167.426 57.0397V56.2096H176.755H176.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_473",
    opacity: 0.6,
    d: "M166.354 50.8451H175.485L174.159 45.6045H165.029L166.354 50.8451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_474",
    d: "M165.109 45.9142H174.234L174.16 45.6045H165.029L165.109 45.9142Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_475",
    d: "M159.392 54.7229H172.091L170.251 47.4319H157.546L159.392 54.7229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_476",
    d: "M157.657 47.8593H170.356L170.251 47.4319H157.546L157.657 47.8593Z",
    fill: "#407BFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_477",
    d: "M222.88 59.2511H31.1648V61.8218C31.1648 62.4041 31.6356 62.8749 32.2179 62.8749H221.82C222.403 62.8749 222.873 62.4041 222.873 61.8218V59.2511H222.88Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_478",
    opacity: 0.6,
    d: "M222.88 59.2511H31.1648V61.8218C31.1648 62.4041 31.6356 62.8749 32.2179 62.8749H221.82C222.403 62.8749 222.873 62.4041 222.873 61.8218V59.2511H222.88Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_479",
    opacity: 0.2,
    d: "M31.1648 59.2511H222.88V61.0599H31.1648V59.2511Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_480",
    d: "M29.3683 59.7219H224.67C225.233 59.7219 225.692 59.2635 225.692 58.6998C225.692 58.1361 225.233 57.6777 224.67 57.6777H29.3683C28.8046 57.6777 28.3462 58.1361 28.3462 58.6998C28.3462 59.2635 28.8046 59.7219 29.3683 59.7219Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_481",
    opacity: 0.6,
    d: "M29.3683 59.7219H224.67C225.233 59.7219 225.692 59.2635 225.692 58.6998C225.692 58.1361 225.233 57.6777 224.67 57.6777H29.3683C28.8046 57.6777 28.3462 58.1361 28.3462 58.6998C28.3462 59.2635 28.8046 59.7219 29.3683 59.7219Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_482",
    d: "M93.5934 56.6308H73.6904L76.992 43.5727C77.0664 43.2878 77.3637 43.0586 77.6672 43.0586H96.4801C96.7774 43.0586 96.9632 43.2878 96.8951 43.5727L93.5934 56.6308Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_483",
    d: "M93.4447 55.5406H74.3965L77.2893 44.0807H96.3438L93.4447 55.5406Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_484",
    opacity: 0.6,
    d: "M93.4447 55.5406H74.3965L77.2893 44.0807H96.3438L93.4447 55.5406Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_485",
    d: "M84.9212 56.2096H64.9933V57.0397C64.9933 57.3927 65.2783 57.6839 65.6376 57.6839H92.9493C93.3024 57.6839 93.5935 57.3989 93.5935 57.0397V56.2096H84.9212Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_486",
    opacity: 0.6,
    d: "M84.9212 56.2096H64.9933V57.0397C64.9933 57.3927 65.2783 57.6839 65.6376 57.6839H92.9493C93.3024 57.6839 93.5935 57.3989 93.5935 57.0397V56.2096H84.9212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_487",
    opacity: 0.2,
    d: "M75.5921 56.2096V56.4945H72.1231V56.2096H64.9994V57.0397C64.9994 57.3927 65.2844 57.6839 65.6436 57.6839H84.283C84.6361 57.6839 84.9272 57.3989 84.9272 57.0397V56.2096H75.5983H75.5921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_488",
    d: "M92.6147 54.6981H75.5116L77.9956 44.886H95.0925L92.6147 54.6981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_489",
    d: "M94.9501 45.4621H77.8469L77.9956 44.886H95.0925L94.9501 45.4621Z",
    fill: "#407BFF"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "&lt;Group&gt;"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_490",
    d: "M56.5932 54.5866L60.6073 55.1875C60.6073 55.1875 61.9701 54.7353 63.4072 54.5866C64.8444 54.4379 66.5107 54.5866 66.5107 54.5866C66.5107 54.5866 68.3257 55.268 68.3257 57.0087C68.3257 57.0087 64.0886 58.1422 62.4595 57.4608L56.5932 57.0087V54.5866Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_491",
    d: "M47.0722 39.286C49.5686 41.8691 51.2721 51.8609 51.7243 52.5423C52.1765 53.2237 60.8055 54.475 60.8055 54.475C60.8055 54.475 61.7161 56.3644 60.8055 57.9192C60.8055 57.9192 50.1137 57.4298 48.8129 56.7484C47.5182 56.067 44.3342 48.6088 44.3342 48.6088C44.3342 48.6088 44.0307 46.6451 44.7554 43.4673C45.474 40.2895 47.066 39.2984 47.066 39.2984L47.0722 39.286Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_492",
    opacity: 0.6,
    d: "M47.0722 39.286C49.5686 41.8691 51.2721 51.8609 51.7243 52.5423C52.1765 53.2237 60.8055 54.475 60.8055 54.475C60.8055 54.475 61.7161 56.3644 60.8055 57.9192C60.8055 57.9192 50.1137 57.4298 48.8129 56.7484C47.5182 56.067 44.3342 48.6088 44.3342 48.6088C44.3342 48.6088 44.0307 46.6451 44.7554 43.4673C45.474 40.2895 47.066 39.2984 47.066 39.2984L47.0722 39.286Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_493",
    d: "M66.0399 25.528C66.0399 25.528 66.5727 26.9961 67.2603 27.9067C67.2603 27.9067 66.7151 28.5571 65.7983 28.3093L66.0399 25.528Z",
    fill: "#D58745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_494",
    d: "M66.7214 24.8218C66.6718 25.2554 66.3993 25.5775 66.1081 25.5404C65.8232 25.5094 65.625 25.1315 65.6807 24.6979C65.7303 24.2643 66.0028 23.9422 66.2878 23.9794C66.5727 24.0103 66.771 24.3882 66.7214 24.8218Z",
    fill: "#2E353A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_495",
    d: "M66.6099 23.0997C66.6099 23.0997 66.2939 23.013 65.9099 23.3475",
    stroke: "#2E353A",
    strokeWidth: 0.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_496",
    d: "M64.9063 30.3846C64.801 30.5766 64.6956 30.7562 64.5779 30.9297C63.878 31.9703 62.8992 32.7323 61.8152 33.1597C61.5302 33.2774 61.2391 33.3641 60.9418 33.4385C59.3745 33.8039 57.6896 33.519 56.364 32.4969C55.8189 32.0881 55.3295 31.5367 54.9392 30.8677C53.3782 28.2227 54.0534 25.8006 54.8587 21.6069C55.0198 20.7025 55.3853 19.8476 55.9366 19.1167C57.8631 16.5336 61.524 16.007 64.101 17.9335C67.7372 20.6096 66.7399 26.897 64.9001 30.3907L64.9063 30.3846Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_497",
    opacity: 0.2,
    d: "M61.8152 33.1597C61.5302 33.2774 61.2391 33.3641 60.9418 33.4384C59.3745 33.8039 57.6896 33.5189 56.364 32.4968C56.8596 31.7721 57.4542 31.2827 57.4542 31.2827C57.4542 31.2827 60.0188 31.5243 61.8152 33.1659V33.1597Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_498",
    d: "M49.7978 36.0649C51.365 38.4312 58.8728 39.3604 58.8728 39.3604C58.8728 39.3604 62.1992 39.2923 61.7904 38.1587C60.0311 37.3906 59.3621 36.3127 59.2692 35.1233C59.2197 34.4296 59.3683 33.7048 59.6099 32.98C59.7338 32.596 59.8949 32.2181 60.0621 31.8526L55.0507 25.7324C56.3578 32.4969 52.3375 34.3862 49.7916 36.0711L49.7978 36.0649Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_499",
    d: "M66.0584 17.6857C64.6399 15.4557 63.3762 15.8459 63.3762 15.8459C62.4718 13.9752 57.1507 13.9008 54.4499 15.7406C51.7491 17.5804 50.8075 21.0246 50.9871 23.7625C51.2473 27.7456 53.7437 31.7969 53.7437 31.7969C56.8843 32.6331 59.5232 31.9455 59.7214 30.2792C59.9258 28.6129 61.6046 27.3801 61.6046 27.3801C63.1532 27.9005 64.5532 26.1784 64.5532 26.1784C64.5532 26.1784 66.3062 24.6298 65.8354 22.4865C65.3647 20.3432 67.2478 19.5564 66.0522 17.6733L66.0584 17.6857Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_500",
    d: "M61.0534 26.2899C61.072 27.25 61.4003 28.0368 61.964 28.4704C62.7135 29.0403 63.5684 27.9934 63.7604 26.7235C63.9215 25.5961 63.748 23.8988 62.794 23.874C61.8401 23.8492 61.041 25.1005 61.0534 26.2899Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_501",
    d: "M63.7974 26.3518C63.7974 26.3518 63.37 29.9633 62.3974 31.4004C61.4249 32.8375 61.5426 33.3269 60.2108 33.5561C60.2108 33.5561 60.9603 34.5534 61.6355 34.4109C62.3107 34.2685 62.1559 33.6986 62.7567 33.7048C63.3514 33.7172 64.3859 33.3021 64.2744 32.6827C64.1629 32.0632 64.0514 31.896 64.8381 31.3632C65.6248 30.8305 65.9035 29.6288 65.4761 29.127C65.0487 28.6252 64.2372 28.7801 64.2372 28.7801L64.2992 26.0917L63.7912 26.3518H63.7974Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_502",
    d: "M60.4402 38.1586C60.4402 38.1586 59.2261 32.7136 51.9227 32.7693L50.0705 35.464L60.4402 38.1586Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_503",
    opacity: 0.8,
    d: "M60.4402 38.1586C60.4402 38.1586 59.2261 32.7136 51.9227 32.7693L50.0705 35.464L60.4402 38.1586Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_504",
    d: "M54.8464 67.6508L56.6676 62.1501C56.6676 62.1501 57.9746 51.96 64.6213 39.125C64.6213 39.125 56.6242 33.4446 47.7598 34.2932C40.9396 34.9436 34.5221 52.4308 32.515 66.2694L54.8464 67.6446V67.6508Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_505",
    opacity: 0.9,
    d: "M32.5088 66.2749L54.8402 67.6563L56.6676 62.1555C56.6676 62.1555 56.8906 60.4149 57.6215 57.4601C58.1295 55.4345 58.8728 52.8266 59.9569 49.8222C61.0966 46.6444 62.6143 43.0082 64.6213 39.1304C64.6213 39.1304 56.6242 33.4562 47.7598 34.2987C40.9334 34.9491 34.5159 52.4301 32.5088 66.2749Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_506",
    opacity: 0.2,
    d: "M57.6217 57.9378C58.1296 56.0051 58.873 53.5211 59.957 50.6592C59.5668 49.854 59.034 49.1416 58.3526 48.6027C58.3526 48.6027 56.2527 55.4352 57.6217 57.9378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_507",
    d: "M75.3689 56.1228L78.7511 55.5777C78.7511 55.5777 80.1139 55.1255 81.551 54.9768C82.9882 54.8282 84.6545 54.9768 84.6545 54.9768C84.6545 54.9768 86.4695 55.6582 86.4695 57.3989C86.4695 57.3989 82.2324 58.5325 80.6033 57.8511L75.6166 58.9785L75.3689 56.1166V56.1228Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_508",
    d: "M64.6214 39.286C66.201 41.0205 65.278 55.206 65.7922 56.1785C66.3063 57.1511 78.1255 55.1874 78.1255 55.1874L78.906 58.6997C78.906 58.6997 65.0117 62.7819 62.4657 62.8315C59.9198 62.881 58.3649 47.8469 58.3649 47.8469C58.3649 47.8469 58.718 45.7531 60.5826 43.0895C62.4471 40.4196 64.6276 39.2922 64.6276 39.2922L64.6214 39.286Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_509",
    opacity: 0.9,
    d: "M64.6214 39.286C66.201 41.0205 65.278 55.206 65.7922 56.1785C66.3063 57.1511 78.1255 55.1874 78.1255 55.1874L78.906 58.6997C78.906 58.6997 65.0117 62.7819 62.4657 62.8315C59.9198 62.881 58.3649 47.8469 58.3649 47.8469C58.3649 47.8469 58.718 45.7531 60.5826 43.0895C62.4471 40.4196 64.6276 39.2922 64.6276 39.2922L64.6214 39.286Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_510",
    d: "M48.2616 88.7742H22.672C22.672 88.7742 14.5385 75.4188 14.5385 53.3539V45.2514C14.5385 41.9249 17.2765 39.2241 20.6526 39.2241H31.5054C34.8133 39.2241 37.5203 41.8196 37.6132 45.0842C37.9291 56.4511 39.6264 81.0744 48.2678 88.7804L48.2616 88.7742Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_511",
    opacity: 0.2,
    d: "M42.6306 88.7742H23.824C23.0993 88.7742 22.4303 88.3778 22.0957 87.7398C20.2436 84.2151 14.5384 71.8384 14.5384 53.3539V45.2514C14.5384 41.9188 17.2702 39.2241 20.6462 39.2241H30.0247C33.3326 39.2241 36.0397 41.8196 36.1326 45.0842C36.4113 55.2432 37.7989 75.9763 44.2536 85.7761C45.1085 87.0708 44.1979 88.7804 42.6368 88.7804L42.6306 88.7742Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "&lt;Group&gt;_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_512",
    d: "M185.303 41.3054L187.18 41.7514L187.614 40.24C187.614 40.24 188.171 40.6117 188.94 40.24C189.15 40.1409 189.441 39.9612 189.763 39.7506C190.6 39.1993 191.591 38.4436 191.591 38.4436L190.141 35.4888C190.141 35.4888 189.509 35.7427 188.735 36.0834C187.645 36.5728 186.276 37.2232 186.034 37.5701C185.625 38.1586 185.83 39.2551 185.83 39.2551L185.303 41.3054Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_513",
    opacity: 0.2,
    d: "M189.763 39.7506C190.6 39.1993 191.591 38.4436 191.591 38.4436L190.141 35.4888C190.141 35.4888 189.509 35.7427 188.735 36.0834C188.667 36.9507 188.735 38.4683 189.763 39.7506Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_514",
    d: "M188.617 29.3129C188.617 29.3129 189.763 29.2819 190.296 30.0996",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_515",
    d: "M189.119 32.0385C189.119 32.0385 188.45 33.0296 187.775 33.5871C187.775 33.5871 188.06 34.1694 188.785 34.1508L189.113 32.0385H189.119Z",
    fill: "#DE5753"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_516",
    d: "M188.537 30.8615C188.494 31.1898 188.636 31.4809 188.859 31.5057C189.076 31.5367 189.293 31.2889 189.33 30.9606C189.373 30.6323 189.231 30.3411 189.008 30.3163C188.791 30.2854 188.574 30.5331 188.537 30.8615Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_517",
    d: "M189.101 30.3411L188.419 29.9695C188.419 29.9695 188.698 30.6199 189.101 30.3411Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_518",
    d: "M197.092 38.7596C197.048 38.7905 197.005 38.8277 196.955 38.8463C196.324 39.2489 195.599 39.633 194.793 39.7755C192.532 40.1843 191.021 39.8002 190.079 38.741C188.76 37.1552 188.543 34.4544 188.896 31.227C189.057 29.7465 189.33 28.4642 189.788 27.4793C189.788 27.4669 189.794 27.4297 189.801 27.4236C189.825 27.3864 189.838 27.3306 189.863 27.2873C190.544 25.9121 191.603 25.051 193.245 24.7475C193.815 24.6422 194.453 24.5988 195.171 24.6236C201.49 24.8652 202.115 35.3835 197.098 38.7534L197.092 38.7596Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_519",
    opacity: 0.2,
    d: "M196.955 38.8462C196.323 39.2489 195.605 39.5462 194.8 39.6887C192.539 40.0975 191.033 39.6391 190.086 38.5675C191.17 38.8648 192.644 39.0259 194.106 38.4374C195.029 38.0657 196.026 38.3259 196.955 38.8524V38.8462Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_520",
    d: "M189.782 27.4359C189.782 27.4359 189.218 31.8464 193.325 33.9588C193.325 33.9588 194.905 38.648 197.556 38.8401C201.168 39.1064 204.612 34.1136 203.615 28.8111C202.32 21.9351 192.049 20.8759 189.788 27.4359H189.782Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_521",
    d: "M191.256 32.5836C191.294 31.8898 191.907 30.7562 192.972 30.9668C194.075 31.1837 194.558 33.9526 191.795 34.4358C191.399 34.5039 191.182 34.0269 191.256 32.5836Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_522",
    d: "M197.724 23.1059C197.724 23.1059 193.549 21.8298 191.133 23.4156C188.308 25.2678 187.174 27.2686 190.247 30.6137C190.247 30.6137 197.457 28.6624 199.786 29.2633C202.122 29.8641 203.776 30.6385 203.776 30.6385C204.5 25.974 200.127 22.2696 197.724 23.1121V23.1059Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_523",
    d: "M193.759 39.3481C193.759 39.3481 196.863 40.8657 195.958 44.1922L203.856 40.9029C203.856 40.9029 199.539 40.6303 199.762 37.595C199.762 37.595 195.246 35.8605 193.759 39.3481Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_524",
    d: "M196.646 23.9608C196.646 23.9608 199 17.1716 204.352 18.3424C209.697 19.5131 209.289 25.2555 205.46 27.0271C201.638 28.805 196.28 28.1297 196.646 23.9608Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_525",
    d: "M203.986 26.9156C203.986 26.9156 208.706 26.8846 208.124 30.9358C208.124 30.9358 207.715 29.6226 206.656 29.0836C206.656 29.0836 208.087 30.1801 206.662 32.0694C206.662 32.0694 207.232 30.8367 205.281 29.9757C203.329 29.1146 197.99 29.1951 198.981 26.5563C199.978 23.9174 203.986 26.9156 203.986 26.9156Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_526",
    d: "M197.482 23.9484C197.482 23.9484 198.622 15.6849 205.287 17.3512",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_527",
    d: "M200.133 36.1144C200.133 36.1144 204.996 33.6552 204.135 29.765",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_528",
    d: "M204.469 26.9465C204.469 26.9465 208.731 26.8784 209.097 29.7836",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_529",
    d: "M203.311 40.6737L201.385 39.2861C201.385 39.2861 195.041 40.1472 194.979 44.186C194.917 48.2249 203.311 40.6737 203.311 40.6737Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_530",
    d: "M204.469 40.6737C204.469 40.6737 199.712 39.7569 193.096 44.186C193.096 44.186 190.879 53.8742 200.245 67.05L217.998 65.935C217.998 65.935 213.191 46.5337 204.469 40.6737Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_531",
    opacity: 0.1,
    d: "M193.635 53.1185C193.933 54.3636 194.341 55.7202 194.886 57.1635C195.995 60.1183 197.686 63.451 200.245 67.05L217.998 65.935C217.998 65.935 213.191 46.5337 204.469 40.6737C204.469 40.6737 199.718 39.7631 193.096 44.186C193.096 44.186 192.316 47.5991 193.635 53.1185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_532",
    opacity: 0.2,
    d: "M193.635 53.1185C193.932 54.3636 194.341 55.7202 194.886 57.1636C195.078 55.0512 194.849 52.7778 194.849 52.7778C194.391 52.8274 193.988 52.9451 193.635 53.1185Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_533",
    d: "M193.096 44.186C193.096 44.186 187.874 51.6937 186.524 52.4123C185.173 53.1309 187.769 40.6737 187.769 40.6737L185.248 40.1285C185.248 40.1285 180.781 55.1069 183.78 57.6839C186.778 60.2608 194.843 52.784 194.843 52.784C194.843 52.784 195.128 49.8416 194.843 47.6363C194.558 45.4311 193.09 44.1922 193.09 44.1922L193.096 44.186Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_534",
    opacity: 0.1,
    d: "M193.096 44.186C193.096 44.186 187.874 51.6937 186.524 52.4123C185.173 53.1309 187.769 40.6737 187.769 40.6737L185.248 40.1285C185.248 40.1285 180.781 55.1069 183.78 57.6839C186.778 60.2608 194.843 52.784 194.843 52.784C194.843 52.784 195.128 49.8416 194.843 47.6363C194.558 45.4311 193.09 44.1922 193.09 44.1922L193.096 44.186Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_535",
    d: "M207.672 88.7742H233.262C233.262 88.7742 241.395 75.4188 241.395 53.3539V45.2514C241.395 41.9249 238.657 39.2241 235.281 39.2241H224.428C221.12 39.2241 218.413 41.8196 218.32 45.0842C218.004 56.4511 216.307 81.0744 207.666 88.7804L207.672 88.7742Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_536",
    opacity: 0.2,
    d: "M213.303 88.7742H232.109C232.834 88.7742 233.503 88.3778 233.838 87.7398C235.69 84.2151 241.395 71.8384 241.395 53.3539V45.2514C241.395 41.9188 238.663 39.2241 235.287 39.2241H225.909C222.601 39.2241 219.894 41.8196 219.801 45.0842C219.522 55.2432 218.135 75.9763 211.68 85.7761C210.825 87.0708 211.736 88.7804 213.297 88.7804L213.303 88.7742Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_6927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 243.532,
    height: 199.755,
    fill: "white",
    transform: "matrix(-1 0 0 1 243.532 -60)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastActionsTopImage);
export default __webpack_public_path__ + "static/media/fast-actions-top-image.c90a3c7faa50352e823fd9613d25b208.svg";
export { ForwardRef as ReactComponent };